/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { StructureControlActionTypeEnum } from "./StructureControlActionTypeEnum";
import {
  StructureControlActionTypeEnumFromJSON,
  StructureControlActionTypeEnumFromJSONTyped,
  StructureControlActionTypeEnumToJSON,
  StructureControlActionTypeEnumToJSONTyped,
} from "./StructureControlActionTypeEnum";
import type { StructureTypeEnum } from "./StructureTypeEnum";
import {
  StructureTypeEnumFromJSON,
  StructureTypeEnumFromJSONTyped,
  StructureTypeEnumToJSON,
  StructureTypeEnumToJSONTyped,
} from "./StructureTypeEnum";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface TimedStructureControl
 */
export interface TimedStructureControl {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   *
   */
  duration: number;
  /**
   *
   */
  value: Array<number>;
  /**
   *
   */
  type: StructureControlActionTypeEnum;
  /**
   *
   */
  structureId?: number | null;
  /**
   *
   */
  structureType: StructureTypeEnum;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  gridId?: number | null;
  /**
   *
   */
  readonly uid?: string;
}

/**
 * Check if a given object implements the TimedStructureControl interface.
 */
export function instanceOfTimedStructureControl(value: object): value is TimedStructureControl {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("duration" in value) || value["duration"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (
    (!("structureType" in (value as Record<string, any>)) &&
      !("structure_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["structureType"] === undefined &&
      (value as Record<string, any>)["structure_type"] === undefined)
  )
    return false;
  return true;
}

export function TimedStructureControlFromJSON(json: any): TimedStructureControl {
  return TimedStructureControlFromJSONTyped(json, false);
}

export function TimedStructureControlFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimedStructureControl {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    duration: json["duration"],
    value: json["value"],
    type: StructureControlActionTypeEnumFromJSON(json["type"]),
    structureId:
      json["structure_id"] === undefined
        ? undefined
        : json["structure_id"] === null
        ? null
        : json["structure_id"],
    structureType: StructureTypeEnumFromJSON(json["structure_type"]),
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
  };
}

export function TimedStructureControlToJSON(json: any): TimedStructureControl {
  return TimedStructureControlToJSONTyped(json, false);
}

export function TimedStructureControlToJSONTyped(
  value?: Omit<
    TimedStructureControl,
    "id" | "url" | "simulation" | "state" | "stateDetail" | "uid"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    value: value["value"],
    type: StructureControlActionTypeEnumToJSON(value["type"]),
    structure_id: value["structureId"],
    structure_type: StructureTypeEnumToJSON(value["structureType"]),
    grid_id: value["gridId"],
  };
}
